"use client"

import { useEffect, useState } from 'react'

export function BlogViewCounter({ slug }: { slug: string }) {
  const [count, setCount] = useState<number | null>(null)

  useEffect(() => {
    let alive = true
    fetch('/api/blog/view-count', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ slug }),
      cache: 'no-store',
    })
      .then((response) => response.json())
      .then((data: { count?: number }) => {
        if (alive && typeof data.count === 'number') setCount(data.count)
      })
      .catch(() => {
        if (alive) setCount(null)
      })
    return () => { alive = false }
  }, [slug])

  return <span>읽음 {count === null ? '-' : count.toLocaleString('ko-KR')}</span>
}
